export default __webpack_public_path__ + "static/media/stage.7caa15b9.fbx";